(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function() {

    // 選取第一層 summary
    var $firstLevelSummaries = $('nav.header__inline-menu > ul > li > header-menu > details > summary.header__menu-item');
    // 為每個元素綁定 mouseenter / mouseleave 事件
    $firstLevelSummaries.each(function() {
        $(this).on('mouseenter', function() {
            let _this = $(this);

            // 先關掉所有的
            $firstLevelSummaries.each(function() {
              $(this).attr('aria-expanded', false);
              $(this).parent().attr('open', false);
            });

            _this.attr('aria-expanded', true);
            _this.parent().attr('open', true);
            _this.next('ul').on('mouseleave', function() {
              _this.attr('aria-expanded', false);
              _this.parent().attr('open', false);
            });
        });
    });

  // 监听购物车数量变化并同步
  function syncCartCounts() {
    // 获取主购物车图标中的数量
    const mainCartBubble = document.querySelector('#cart-icon-bubble .cart-count-bubble');
    // 获取需要同步的目标购物车图标
    const targetCartBubble = document.querySelector('#cart-icon-bubble1 .cart-count-bubble');

    if (mainCartBubble && targetCartBubble) {
      // 获取购物车中的数量文本
      const countSpan = mainCartBubble.querySelector('span[aria-hidden="true"]');
      const visibleSpan = mainCartBubble.querySelector('.visually-hidden');

      if (countSpan) {
        // 同步显示的数字
        const targetCountSpan = targetCartBubble.querySelector('span[aria-hidden="true"]');
        if (targetCountSpan) {
          targetCountSpan.textContent = countSpan.textContent;
        }
      }

      if (visibleSpan) {
        // 同步屏幕阅读器文本
        const targetVisibleSpan = targetCartBubble.querySelector('.visually-hidden');
        if (targetVisibleSpan) {
          targetVisibleSpan.textContent = visibleSpan.textContent;
        }
      }
    }
  }

  // 设置一个变化观察器
  const mainCart = document.querySelector('#cart-icon-bubble');
  if (mainCart) {
    const observer = new MutationObserver(syncCartCounts);
    observer.observe(mainCart, {
      childList: true,
      subtree: true,
      characterData: true
    });
  }

  // 页面加载时同步一次
  syncCartCounts();

  // 在购物车更新时同步
  document.addEventListener('cart:updated', syncCartCounts);
});
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
